'use strict';

var Promise = require('es6-promise').Promise;

Promise.polyfill();

const vMediaQuery = require('v-media-query');

import Vue from 'vue';

import bootbox from 'bootbox';

Vue.use(vMediaQuery.default);

const components = {
    login: require('./vue/components/login-modal.vue').default,
    'login-button': require('./vue/components/login-button.vue').default,
    'login-form': require('./vue/components/login-form.vue').default,
    categories: require('./vue/components/categories.vue').default,
    'like-post-button': require('./vue/components/blog-like.vue').default,
    'like-comment-button': require('./vue/components/blog-like-comment.vue').default,
    'comment-likes': require('./vue/components/blog-comment-likes.vue').default,
    'follow-blog-button': require('./vue/components/blog-follow.vue').default,
    'blog-presentation': require('./vue/components/blog-presentation.vue').default,
    'select-visibility': require('./vue/components/select-visibility.vue').default,
    'archive-year': require('./vue/components/blog-archive-year.vue').default,
    'menu-popup-container': require('./vue/components/menu-popup-container.vue').default,
    'menu-chart': require('./vue/components/menu-chart.vue').default,
    'menu-meal-chart': require('./vue/components/menu-meal-chart.vue').default,
    'menu-day-chart': require('./vue/components/menu-day-chart.vue').default,
    'menu-ingredient-chart': require('./vue/components/menu-ingredient-chart.vue').default,
    'recipe-instructions': require('./vue/components/recipe-instructions.vue').default,
    'recipe-ingredient-tab': require('./vue/components/recipe-ingredient-tab.vue').default,
    'recipe-spice-tab': require('./vue/components/recipe-spice-tab.vue').default,
    'recipe-ingredients': require('./vue/components/recipe-ingredients.vue').default,
    'recipe-categories': require('./vue/components/recipe-categories.vue').default,
    'diet-tags': require('./vue/components/diet-tags.vue').default,
    'recipe-dropzone': require('./vue/components/recipe-dropzone.vue').default,
    'recipe-filter': require('./vue/components/recipe-filter.vue').default,
    'recipe-list': require('./vue/components/recipe-list.vue').default,
    'recipe-search': require('./vue/components/recipe-search.vue').default,
    'recipe-quick-search': require('./vue/components/recipe-quick-search.vue').default,
    'recipe-rating': require('./vue/components/recipe-rating.vue').default,
    'recipe-ingredients-list': require('./vue/components/recipe-ingredients-list.vue').default,
    'recipe-actions': require('./vue/components/recipe-actions.vue').default,
    charts: require('./vue/components/charts.vue').default,
    'diet-schedule-form': require('./vue/components/diet-schedule-form.vue').default,
    'food-diary-form': require('./vue/components/food-diary-form.vue').default,
    'grocery-list-form': require('./vue/components/grocery-list-form.vue').default,
    'menu-diet-date': require('./vue/components/menu-diet-date.vue').default,
    'menu-form': require('./vue/components/menu-form.vue').default,
    'menu-actions': require('./vue/components/menu-actions.vue').default,
    'menu-add-meal-to-diary': require('./vue/components/menu-add-meal-to-diary.vue').default,
    'forum-like': require('./vue/components/forum-like.vue').default,
    'forum-comment-like': require('./vue/components/forum-comment-like.vue').default,
    challange: require('./vue/components/challange.vue').default,
    'challange-counter': require('./vue/components/challange-counter.vue').default,
    'add-weight-measurement': require('./vue/components/add-weight-measurement.vue').default,
    'weight-measurement': require('./vue/components/weight-measurement.vue').default,
    'filter-weight-measurement': require('./vue/components/filter-weight-measurement.vue').default,
    'swedbank-script': require('./vue/components/swedbank-script.vue').default,
    'swedbank-script-card': require('./vue/components/swedbank-script-card.vue').default,
    'tracking-payment': require('./vue/components/tracking-payment.vue').default,
    'tracking-base': require('./vue/components/tracking-base.vue').default,
    'other-scripts': require('./vue/components/other-scripts.vue').default,
    'food-item-search': require('./vue/components/food-item-search.vue').default
};

const app = new Vue({
    el: '#content-wrapper',
    components: components,

    data: {
        pepInProgress: false,
        userPepped: false,
        updateCommentInProgress: false,
        updatingComment: null
    },

    computed: {
        isScreenBelow768() {
            return this.$mq.resize && this.$mq.below(768);
        }
    },

    methods: {
        pepUser: function (url, username) {
            if (this.pepInProgress) {
                return;
            }

            this.pepInProgress = true;

            request.post(url).end((err, res) => {
                if (err) {
                    console.error(err);
                } else {
                    const message =
                        res.status === 201
                            ? 'Tack för att du peppa ' + username + '!'
                            : 'Du har redan peppat ' + username;

                    bootbox.dialog({
                        message: message,
                        title: 'Peppa'
                    });

                    this.pepInProgress = false;

                    setTimeout(bootbox.hideAll, 5000);
                }
            });
        },

        editComment: function (commentId) {
            if (this.updatingComment !== commentId) {
                this.updatingComment = commentId;

                if (!CKEDITOR.instances['comment-textarea-' + commentId]) {
                    CKEDITOR.replace('comment-textarea-' + commentId, {
                        extraPlugins: 'simpleuploads,smiley',
                        contentsCss: [
                            CKEDITOR.basePath + 'contents.css', // CKEditors standard
                            '/assets/css/ckeditor.css',
                            '/assets/css/default-table.css' // din egen
                        ],
                        height: '25vh',
                        width: '100%',
                        allowedContent:
                            'b; strong; i; u; em; a[href,title]; ul; ol; li; p[style]; br;img[width,height,alt,src]; table;',
                        toolbarGroups: [
                            {
                                name: 'basicstyles',
                                groups: ['basicstyles', 'cleanup']
                            },
                            { name: 'colors' },
                            {
                                name: 'paragraph',
                                groups: ['list', 'indent', 'blocks', 'align', 'bidi']
                            },
                            { name: 'links' },
                            { name: 'insert' },
                            { name: 'tools' }
                        ]
                    });
                }
            } else {
                this.updatingComment = null;
            }
        },

        updateComment: function (commentId, url = '/blogg/api/comments/') {
            const content = CKEDITOR.instances['comment-textarea-' + commentId].getData();
            const ratingInput = document.querySelector('input[name="update-rating"]:checked');
            const rating = ratingInput ? ratingInput.value : '';

            this.updateCommentInProgress = true;

            request
                .post(url + commentId)
                .send({
                    message: content,
                    rating: rating
                })
                .end((err, res) => {
                    if (err) {
                        console.error(err);
                    }

                    $('#content-wrapper #comment-body-' + commentId).html(res.body.body);

                    this.updateCommentInProgress = false;
                    this.updatingComment = null;
                });
        }
    }
});

app.$mount('#content-wrapper');
